import Swiper from "swiper";
import { A11y, Autoplay, EffectFade } from "swiper/modules";
import "@/styles/components/slider.css";

document.querySelectorAll(".element-reviews").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".swiper-slide").length;

  if (numSlides < 2) {
    return;
  }

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay, EffectFade],
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    slidesPerView: 1,
    speed: 1000,
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.autoplay.start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
